// src/components/Cart/CartButtonWrapper.js
import React from "react";
import { useLocation } from "react-router-dom";
import CartButton from "./CartButton";

const CartButtonWrapper = () => {
  const location = useLocation();
  const hiddenPaths = [
    "/login",
    "/signup",
    "/forgot-password",
    "/reset-password",
    "/confirm-email",
  ];

  if (hiddenPaths.includes(location.pathname)) {
    return null;
  }

  return <CartButton />;
};

export default CartButtonWrapper;
